/**
 * First component rendered:
 * Sets up user store
 * Also declares what a private route is
 * and deals with routing throughout the app
 */

// service
import React, {Component} from 'react';
import firebase from 'firebase';
import {observer} from "mobx-react";
import {BrowserRouter as Router, Route, Redirect} from 'react-router-dom';

// page component
import GrantAdmin from './components/Dashboard/GrantAdmin';
import StudentStats from './components/Dashboard/StudentStats.js';
import AdminHome from './components/Dashboard/MainDashboard.js';
import CreateSession from './components/Dashboard/CreateSession.js';
import userStore from './stores/UserStore';
import Container from './components/Orderbook/SimulationContainer.js';
import ContainerTutorial from './components/OrderbookTutorial/ContainerTutorial.js';
import HeaderScreen from "./screens/HeaderScreen";

//Screen seen if not authed
// const Home = () => (
//     <div>
//         <h2>Home</h2>
//         <p>Please sign-in with your UDel email using the button in the top right corner</p>
//     </div>
// );

/**
 * Deals with private routes and passing props through routes
 * @param component
 * @param rest
 */
const renderMergedProps = (component, ...rest) => {
    const finalProps = Object.assign({}, ...rest);
    return (
        React.createElement(component, finalProps)
    );
};

const PrivateRoute = ({component: Component, authed, ...rest}) => (
    <Route {...rest}
           render={(props) => authed === true
               ?
               (renderMergedProps(Component, props, rest))
               :
               <Redirect to={
                   {
                       pathname: '/',
                       state: {from: props.location}
                   }}/>}
    />
);

let institution = 'default';

@observer
class App extends Component {
    constructor(props) {
        //console.log("App constructor");
        super(props);
        this.state = {
            shouldRedirect: false,
            redirectPath: "",
            time: false
        }
    }

    updateTime(thetime){
      console.log("settingState", thetime);
      this.setState({time: thetime});
    }
    /**
     *  Deals with sending data to mobX
     */
    componentDidMount() {
        //console.log("App componentDidMount");
        this.userStateChange = firebase.auth().onAuthStateChanged((user) => {
            if (user) {
                userStore.login();
                let rando = Math.floor(Math.random()*100000);
                let old = window.localStorage.getItem('tempid');
                if (!old) {
                  window.localStorage.setItem('tempid', rando);
                } else {
                  rando = old;
                }
                userStore.fetchUserInfo(user.email || `demoUser${rando}@gmail.com`, user.displayName || `Demo User ${rando}`, user.photoURL || '', user.uid || `${rando}`);
                //institution = userStore.email.replace(/.*@/, "");
                //institution = institution.replace(/\..*/, "");
                institution = 'baruchlive';
                //roleName = userStore.email.replace(/@.*/,"");
                //alert(roleName);
                //userStore.fetchUserRole(roleName)
                this.setState({
                    shouldRedirect: true,
                    redirectPath: "/Home"
                })
            } else {
                userStore.logout();
                this.setState({
                    shouldRedirect: true,
                    redirectPath: "/"
                });
                console.log("logged out")
            }
        })
    }

    componentWillUnmount() {
        //console.log("App componentWillUnmount");
        this.userStateChange();
        sessionStorage.clear();
    }

    render() {
        console.log("App render");
        return (
            <Router>
                <div>
                    <HeaderScreen user={userStore} time={this.state.time}/>
                    <div className="app">
                        {/*<Route exact path="/" component={Home}/>*/}
                        <PrivateRoute
                            authed={userStore.authed}
                            institution={institution}
                            path="/CreateSession"
                            user={userStore}
                            component={CreateSession}
                        />
                        {/*<PrivateRoute*/}
                        {/*authed={userStore.authed}*/}
                        {/*institution={institution}*/}
                        {/*path="/AdminHome"*/}
                        {/*user={userStore}*/}
                        {/*component={AdminHome}*/}
                        {/*/>*/}
                        <PrivateRoute
                            authed={userStore.authed}
                            institution={institution}
                            path="/Home"
                            user={userStore}
                            dbs={this.props.dbs}
                            component={AdminHome}
                        />
                        {/* <PrivateRoute authed={userStore.authed} path="/AdminSessionContainer" component={AdminSessionContainer} /> */}
                        <PrivateRoute
                            authed={userStore.authed}
                            institution={institution}
                            path="/ManageAdmin"
                            component={GrantAdmin}
                        />
                        <PrivateRoute
                            authed={userStore.authed}
                            institution={institution}
                            path="/Stats"
                            dbs={this.props.dbs}
                            user={userStore}
                            component={StudentStats}
                        />
                        <PrivateRoute
                            authed={userStore.authed}
                            institution={institution}
                            path="/Tutorial"
                            user={userStore}
                            component={ContainerTutorial}
                        />
                        <PrivateRoute
                            authed={userStore.authed}
                            institution={institution}
                            path="/Simulation"
                            dbs={this.props.dbs}
                            user={userStore}
                            component={Container}
                            updateTime={this.updateTime.bind(this)}
                        />
                        {this.state.shouldRedirect && (<Redirect to={this.state.redirectPath}/>)}
                    </div>
                </div>
            </Router>
        );
    }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js